/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_SubtitleInputs */

const es_components_buy_messages_modal_subtitle = /** @type {(inputs: Components_Buy_Messages_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregá mensajes adicionales a tu cuenta de forma inmediata.`)
};

const en_components_buy_messages_modal_subtitle = /** @type {(inputs: Components_Buy_Messages_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add extra messages to your account instantly.`)
};

/**
* | output |
* | --- |
* | "Add extra messages to your account instantly." |
*
* @param {Components_Buy_Messages_Modal_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_subtitle = /** @type {((inputs?: Components_Buy_Messages_Modal_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_subtitle(inputs)
	return en_components_buy_messages_modal_subtitle(inputs)
});
export { components_buy_messages_modal_subtitle as "components.buy_messages_modal.subtitle" }